import script from "./DesovaOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./DesovaOrders.vue?vue&type=script&setup=true&lang=js"

import "./DesovaOrders.vue?vue&type=style&index=0&id=36fd579d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fd579d"]])

export default __exports__